import type { TenantStateSet } from '@chatbot/shared-types';

/**
 * La etiqueta que ESTE tenant le puso a un estado (ADR-023).
 *
 * Duplica `stateLabel` de `@chatbot/shared-types` a propósito, y vale la pena
 * explicar por qué antes de que alguien lo "arregle" importándolo:
 *
 * `shared-types` se publica como **CommonJS** (`main: dist/index.js`, sin
 * `module` ni `exports`), y `index.js` reexporta con `export *`. Rollup no puede
 * trazar un named export por esa cadena, así que `vite build` falla con
 * *"stateLabel is not exported"*. Todo el resto del panel importa de ahí sólo
 * `import type`, que se borra al compilar — por eso nunca había pasado.
 *
 * Y no lo atrapa ni `pnpm typecheck` ni `vitest`: los dos resuelven a fuente.
 * Sólo `vite build`. Fue rojo en CI con los tres gates locales en verde.
 *
 * **El arreglo de fondo** es que `shared-types` emita ESM o declare un mapa de
 * `exports`. Toca 23 paquetes y merece su propio PR; hasta entonces, la frontera
 * del panel con `shared-types` es de tipos y nada más.
 *
 * Cae al id si el estado ya no está declarado: la config cambia, y los casos
 * históricos que lo tienen se siguen leyendo.
 */
export function stateLabel(set: TenantStateSet, id: string): string {
  return set.find((estado) => estado.id === id)?.label ?? id;
}
